export default {
  user: (state) => { return state.user },
  firebaseUser: (state) => { return state.firebaseUser }
};


// WEBPACK FOOTER //
// ./src/store/user/getters.js